import designs from "../services/designs";
import notification from "../services/notification";
import { getField, updateField } from "vuex-map-fields";
import router from "../router";

const getOrderStatusInitialData = (status) => {

   const initialData =  {
    status,
    header_image: "",
    status_icon: "",
    status_color: "#00AFAA",
    enable_status_color: true,
   }

   if (status === "pick_up") {
    initialData.same_dispatched_header_image = false;
    initialData.same_dispatched_status_icon = false;
   }

   if (status === "claimed") {
    initialData.same_delivered_header_image = false;
    initialData.same_delivered_status_icon = false;
   }

   return initialData;
};

export default {
    namespaced: true,

    state: {
        loading: false,
        details: {
            name: "Design name",
            logo_image: null,
            background_image: null,
            color: "#EBECF0",
            button_color: "#FF8828",
            font_color: "#212121",
            dark_mode: false,
        },
        customerDesignList: [],
        merchantDesignList: [],
        gLifeDesignList: [],
        gLifeDesignDetails: null,
        errors: null,
        featureBanner: null,
        featuredBannerList: null,
        published: null,
        webDesigns: null,
        specificWebDesign: null,
        newsAndPopups: [],
        activeListType: "saved",
        generalSettings: {
            is_sequential_posting: false,
            recurrence_days: [],
            recurrence_type: "day",
            recurrence_value: 1,
            sequentials: [],
            id: null,
            is_recurrence_weeks: false,
            is_recurrence_months: false
        },
        saving: false,
        webFavicon: null,
        appIcon: '',
        webLogo: '',
        aboutUsImage: '',
        advancedSettingsOurBrands: {},
        advancedSettingsCategories: {},
        aboutUs: {},
        iconsAndLogos: {},
        snippetDetails: {},
        advancedSettingsWebSequence: [
            {
                name: "About Us",
                enable: false,
                weight: 1,
                key: "about_us"
            },
            {
                name: "Categories",
                enable: false,
                weight: 2,
                key: "categories"
            },
            {
                name: "Our Brands",
                enable: false,
                weight: 3,
                key: "our_brands"
            },
            // {
            //     name: "Featured Products",
            //     enable: false,
            //     weight: 4,
            //     key: "featured_products"
            // },
            {
                name: "What's Nearby",
                enable: true,
                weight: 4,
                key: "whats_nearby"
            }
        ],
        orderStatusSettings: {
            web_settings: {
                enable: true,
                pending: getOrderStatusInitialData("pending"),
                processing: getOrderStatusInitialData("processing"),
                dispatched: getOrderStatusInitialData("dispatched"),
                pick_up: getOrderStatusInitialData("pick_up"),
                delivered: getOrderStatusInitialData("delivered"),
                claimed: getOrderStatusInitialData("claimed")
            },
            customer_app_settings: {
                enable: true,
                pending: getOrderStatusInitialData("pending"),
                processing: getOrderStatusInitialData("processing"),
                dispatched: getOrderStatusInitialData("dispatched"),
                pick_up: getOrderStatusInitialData("pick_up"),
                delivered: getOrderStatusInitialData("delivered"),
                claimed: getOrderStatusInitialData("claimed")
            },
            glife_settings: {
                enable: true,
                is_same_as_customer_app: false,
                pending: getOrderStatusInitialData("pending"),
                processing: getOrderStatusInitialData("processing"),
                dispatched: getOrderStatusInitialData("dispatched"),
                pick_up: getOrderStatusInitialData("pick_up"),
                delivered: getOrderStatusInitialData("delivered"),
                claimed: getOrderStatusInitialData("claimed")
            }
        },
        files: {},
    },

    mutations: {
        updateField,
        loading(state, value) {
            state.loading = value;
        },

        getDetails(state, details) {
            state.details = details.theme;
            state.loading = false;
        },

        customerList(state, details) {
            state.customerDesignList = details.themes;
            state.loading = false;
        },

        merchantList(state, details) {
            state.merchantDesignList = details.themes;
            state.loading = false;
        },

        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },

        featureBanner(state, featureBanner) {
            state.featureBanner = featureBanner;
        },

        featuredBannerList(state, featuredBannerList) {
            state.featuredBannerList = featuredBannerList;
        },

        published(state, published) {
            state.published = published;
        },

        webDesigns(state, webDesigns) {
            state.webDesigns = webDesigns;
        },

        specificWebDesign(state, specificWebDesign) {
            state.specificWebDesign = specificWebDesign;
        },

        setNewsAndPopup(state, list) {
            state.newsAndPopups = list;
        },

        setActiveListType(state, payload) {
            state.activeListType = payload;
        },

        SET_GENERAL_SETTINGS(state, settings) {
            state.generalSettings = {
                is_sequential_posting: settings.is_sequential_posting,
                recurrence_days: typeof settings.recurrence_days === "string" ? JSON.parse(settings.recurrence_days) : settings.recurrence_days,
                recurrence_type: settings.recurrence_type,
                recurrence_value: settings.recurrence_value,
                sequentials: settings.sequentials,
                id: settings.id,
                is_recurrence_weeks: settings.is_recurrence_weeks,
                is_recurrence_months: settings.is_recurrence_months
            };
        },

        SET_SAVING(state, value) {
            state.saving = value;
        },
        setWebFavicon(state, value) {
            state.webFavicon = value;
        },
        setAppIcon(state, value) {
            state.appIcon = value;
        },
        setWebLogo(state, value) {
            state.webLogo = value;
        },
        setAboutUsImage(state, value) {
            state.aboutUsImage = value;
        },

        SET_WEBSETTINGS_OURBRANDS(state, ourBrands) {
            if (!ourBrands.our_brands) ourBrands.our_brands = [
                {
                    uuid: null,
                    name: null,
                    logo: null
                },
                {
                    uuid: null,
                    name: null,
                    logo: null
                }
            ]; // initialize our_brands array if settings is null
            state.advancedSettingsOurBrands = ourBrands;
        },

        SET_WEBSETTINGS_CATEGORIES(state, categories) {
            if (!categories.categories) categories.categories = [
                {
                    uuid: null,
                    name: null,
                    background_color: "#FF8828"
                },
                {
                    uuid: null,
                    name: null,
                    background_color: "#FF8828"
                }
            ]; // initialize categories array if settings is null
            state.advancedSettingsCategories = categories;
        },
        setAboutUs(state, value) {
            state.aboutUs = value
        },
        setIconsAndLogos(state, value) {
            state.iconsAndLogos = value
        },
        setSnippetDetails(state, value) {
            state.snippetDetails = value
        },
        SET_WEBSETTINGS_WEBSEQUENCE(state, web_sequence) {
            const sections = state.advancedSettingsWebSequence;
            const acceptableKeys = sections.map(section => section.key);
            Object.keys(web_sequence).forEach(key => {
                if (acceptableKeys.includes(key.split('.')[0])) {
                    const section = sections.find(section => section.key === key.split('.')[0]);
                    section[key.split('.').pop()] = web_sequence[key];
                }
            });
        },
        setOrderStatusSettings(state, value) {
            state.orderStatusSettings = value
        },
        setFiles(state, value) {
            state.files = value
        },
        setErrors(state, payload) {
          state.errors = payload;
        },
        setGLifeDesignList(state, payload) {
          state.gLifeDesignList = payload;
        },
        setGLifeDesignDetails(state, payload) {
          state.gLifeDesignDetails = payload;
        }
    },

    getters: {
        getField,
        newsAndPopups: (state) => state.newsAndPopups,
        loading: (state) => state.loading,
        activeListType: (state) => state.activeListType,
        generalSettings: (state) => state.generalSettings,
        errors: (state) => state.errors,
        popUps: state => state.newsAndPopups.filter(popup => popup.type === 'banner' || popup.type === 'poster'),
        saving: state => state.saving,
        ourBrands: state => state.advancedSettingsOurBrands,
        categories: state => state.advancedSettingsCategories,
        advancedSettingsWebSequence: state => state.advancedSettingsWebSequence
    },

    actions: {
        async setCustomerListPublishedFalse({ commit }, list) {
            commit("customerList", { themes: list });
        },
        async setMerchantListPublishedFalse({ commit }, list) {
            commit("merchantList", { themes: list });
        },
        async getCustomerDesigns({ commit }) {
            commit("loading", true);
            try {
                let response = await designs.getCustomerDesigns();
                commit("customerList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getCustomerDesignDetails({ commit }, uuid) {
            commit("loading", true);

            try {
                let response = await designs.getCustomerDesignDetails(uuid);
                commit("getDetails", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async createCustomerDesign({ commit }, param) {
            commit("loading", true);

            try {
                let response = await designs.createCustomerDesign(param);
                commit("loading", false);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateCustomerDesign({ commit }, param) {
            commit("loading", true);

            try {
                let response = await designs.updateCustomerDesign(
                    param.uuid,
                    param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishCustomerDesign({ commit }, data) {
            commit("loading", true);

            try {
                let response = await designs.publishCustomerDesign(data);
                if (data.notify) {
                    notification.success(response.message);
                }
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteCustomerDesign({ commit }, uuid) {
            commit("loading", true);

            try {
                let response = await designs.deleteCustomerDesign(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getMerchantDesigns({ commit }) {
            commit("loading", true);

            try {
                let response = await designs.getMerchantDesigns();
                commit("merchantList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getMerchantDesignDetails({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.getMerchantDesignDetails(uuid);
                commit("getDetails", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async createMerchantDesign({ commit }, param) {
            commit("loading", true);

            try {
                let response = await designs.createMerchantDesign(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                notification.error(errors);
                commit("loading", false);
            }
        },
        async updateMerchantDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.updateMerchantDesign(
                    param.uuid,
                    param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishMerchantDesign({ commit }, data) {
            commit("loading", true);
            try {
                let response = await designs.publishMerchantDesign(data);
                if (data.notify) {
                    notification.success(response.message);
                }
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteMerchantDesign({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.deleteMerchantDesign(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishFeatureBanner({ commit }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                commit("loading", true);
                let response = await designs.publishFeatureBanner(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("loading", true);
                console.log(errors)
                if (errors.status == 400)
                    notification.warning(errors.errors.message);
                else
                    notification.warning("Oops, cannot save banner.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewFeatureBanner({ commit }, uuid) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await designs.viewFeatureBanner(uuid);
                commit("featureBanner", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateFeatureBanner({ commit }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await designs.updateFeatureBanner(
                    param.uuid,
                    param
                );
                notification.success(response.message);
                commit("loading", false);
                commit("errors", null);
            } catch (errors) {
                notification.warning("Oops, cannot save banner.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteFeatureBanner({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.deleteFeatureBanner(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getFeaturedBannerList({ commit }) {
            commit("loading", true);
            try {
                let response = await designs.getFeaturedBannerList();
                commit("featuredBannerList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.publishDesign(param);
                notification.success(response.message);
                commit("published", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("You have already reached the maximum limit of active banners. Please de-activate other existing banners.")
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async createWebDesign({ commit }, param) {
            commit("loading", true);
            try {
                const response = await designs.createWebDesign(param);
                notification.success(response.message);
                commit("errors", null);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot save design.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getWebDesigns({ commit }) {
            commit("loading", true);
            try {
                let response = await designs.getWebDesigns();
                commit("webDesigns", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteWebDesign({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.deleteWebDesign(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewWebDesign({ commit }, uuid) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await designs.viewWebDesign(uuid);
                commit("specificWebDesign", response.web_design);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateWebDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.updateWebDesign(param.uuid, param);
                notification.success(response.message);
                commit("loading", false);
                commit("errors", null);
            } catch (errors) {
                notification.warning("Oops, cannot save banner.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishWebDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.publishWebDesign(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        // News & Pop Up
        async getNewsPopUp({ commit }, param) {
            commit("loading", true);
            try {
                const response = await designs.getNewsPopUp(param);
                commit("setNewsAndPopup", JSON.parse(response.list));
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getGeneralSettings({ commit }) {
            commit("loading", true);
            try {
                const response = await designs.getGeneralSettings();
                commit("SET_GENERAL_SETTINGS", response.settings);
            } catch (errors) {
                commit("errors", errors.errors);
            } finally {
                commit("loading", false);
            }
        },
        async saveGeneralSettings({ commit }, param) {
            commit("SET_SAVING", true);
            commit("errors", null);
            try {
                const response = await designs.saveGeneralSettings(param);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors.errors);
                notification.warning("Oops, cannot save news settings.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async getAdvancedSettingsOurBrands({ commit }) {
            commit("loading", true);
            try {
                const { data } = await designs.getAdvancedSettingsOurBrands();
                commit("SET_WEBSETTINGS_OURBRANDS", data);
            } catch (errors) {
                commit("errors", errors.errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("loading", false);
            }
        },
        async getAboutUs({ commit }) {
            commit("loading", true);
            try {
                const { data } = await designs.getAboutUs();
                commit("setAboutUs", data);
            } catch (errors) {
                commit("errors", errors.errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("loading", false);
            }
        },
        async saveAdvancedSettingsOurBrands({ commit }, payload) {
            commit("SET_SAVING", true);
            try {
                const { message } = await designs.saveAdvancedSettingsOurBrands(payload);
                notification.success(message);
            } catch ({ errors }) {
                const _errors = {};
                Object.keys(errors).forEach(key => {
                    const msg = errors[key].split(".").pop();
                    _errors[key] = `${msg.charAt(0).toUpperCase()}${msg.slice(1)}.`;
                });
                commit("errors", _errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async saveAboutUs({ commit }, payload) {
            commit("SET_SAVING", true);
            try {
                const { message } = await designs.saveAboutUs(payload);
                notification.success(message);
            } catch ({ errors }) {
                const _errors = {};
                Object.keys(errors).forEach(key => {
                    const msg = errors[key].split(".").pop();
                    _errors[key] = `${msg.charAt(0).toUpperCase()}${msg.slice(1)}.`;
                });
                commit("errors", _errors);
                console.log(errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async getAdvancedSettingsCategories({ commit }) {
            commit("loading", true);
            try {
                const { data } = await designs.getAdvancedSettingsCategories();
                commit("SET_WEBSETTINGS_CATEGORIES", data);
            } catch ({ errors }) {
                commit("errors", errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("loading", false);
            }
        },
        async saveAdvancedSettingsCategories({ commit }, payload) {
            commit("SET_SAVING", true);
            try {
                const { message } = await designs.saveAdvancedSettingsCategories(payload);
                notification.success(message);
            } catch ({ errors }) {
                const _errors = {};
                Object.keys(errors).forEach(key => {
                    const msg = errors[key].split(".").pop();
                    _errors[key] = `${msg.charAt(0).toUpperCase()}${msg.slice(1)}.`;
                });
                commit("errors", _errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async saveIconsAndLogos({ commit }, payload) {
            commit("errors", null);
            commit("SET_SAVING", true);

            try {
                const { message } = await designs.saveIconsAndLogos(payload);
                notification.success(message);
            } catch ({ errors }) {
                const _errors = {};
                Object.keys(errors).forEach(key => {
                    const msg = errors[key].split(".").pop();
                    _errors[key] = `${msg.charAt(0).toUpperCase()}${msg.slice(1)}.`;
                });
                commit("errors", _errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async getIconsAndLogos({ commit }) {
            commit("loading", true);
            try {
                const { data } = await designs.getIconsAndLogos();

                commit("setIconsAndLogos", data);
            } catch (errors) {
                commit("errors", errors.errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("loading", false);
            }
        },
        async getSnippetDetails({ commit }) {
            commit("loading", true);
            try {
                const { data } = await designs.getSnippetDetails();

                commit("setSnippetDetails", data);
            } catch (errors) {
                commit("errors", errors.errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("loading", false);
            }
        },
        async getAdvancedSettingsWebSequence({ commit }) {
            commit("loading", true);
            try {
                const { data } = await designs.getAdvancedSettingsWebSequence();
                await commit("SET_WEBSETTINGS_WEBSEQUENCE", data.sections);
            } catch ({ errors }) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async saveAdvancedSettingsWebSequence({ commit }, payload) {
            commit("SET_SAVING", true);
            try {
                const { message } = await designs.saveAdvancedSettingsWebSequence(payload);

                if (router.currentRoute.name !== "onboarding")
                  notification.success(message);
            } catch ({ errors }) {
                commit("errors", errors);
                notification.warning("Cannot save web sequence.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async saveSnippetDetails({ commit }, payload) {
            commit("SET_SAVING", true);

            try {
                const { message } = await designs.saveSnippetDetails(payload);
                notification.success(message);
            } catch ({ errors }) {
                const _errors = {};
                Object.keys(errors).forEach(key => {
                    const msg = errors[key].split(".").pop();
                    _errors[key] = `${msg.charAt(0).toUpperCase()}${msg.slice(1)}.`;
                });
                commit("errors", _errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async saveOrderStatusSettings({ commit }, payload) {
            commit("SET_SAVING", true);
            commit("errors", null);

            try {
                const { message } = await designs.saveOrderStatusSettings(payload);
                notification.success(message);
            } catch ({ errors }) {
                commit("errors", errors);

                Object.values(errors).map(error => {
                    notification.warning(error);
                });
            } finally {
                commit("SET_SAVING", false);
            }
        },
        async getOrderStatusSettings({ commit, state }) {
            commit("loading", true);
            commit("errors", null);

            try {
                const {
                    web_settings,
                    customer_app_settings,
                    glife_settings
                } = await designs.getOrderStatusSettings();

                commit("setOrderStatusSettings", {
                    web_settings: web_settings && web_settings.constructor.name === 'Object' ?
                        web_settings :
                        state.orderStatusSettings.web_settings,
                    customer_app_settings: customer_app_settings && customer_app_settings.constructor.name === 'Object' ?
                        customer_app_settings :
                        state.orderStatusSettings.customer_app_settings,
                    glife_settings: glife_settings && glife_settings.constructor.name === 'Object' ?
                        glife_settings :
                        state.orderStatusSettings.glife_settings,
                });
            } catch ({ errors }) {
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("setFiles", {
                    web_settings: {
                        pending: {},
                        processing: {},
                        dispatched: {},
                        pick_up: {},
                        delivered: {},
                        claimed: {}
                    },
                    customer_app_settings: {
                        pending: {},
                        processing: {},
                        dispatched: {},
                        pick_up: {},
                        delivered: {},
                        claimed: {}
                    },
                    glife_settings: {
                        pending: {},
                        processing: {},
                        dispatched: {},
                        pick_up: {},
                        delivered: {},
                        claimed: {}
                    }
                })
                commit("loading", false);
            }
        },
        async getGLifeDesignList({ commit }) {
            commit("loading", true);
            commit("setErrors", null);

            try {
                const { data } = await designs.getGLifeDesignList();

                commit("setGLifeDesignList", data);
            } catch (errors) {
                commit("setErrors", errors);
                notification.warning("Oops, something went wrong.");
            } finally {
                commit("loading", false);
            }
        },
        async createGLifeDesign({ commit }, data) {
          commit("loading", true);
          commit("setErrors", null);

          try {
            const { message } = await designs.createGLifeDesign(data);
            notification.success(message);
          } catch (errors) {
            commit("setErrors", errors);
            notification.warning("Oops, something went wrong.");
          } finally {
            commit("loading", false);
          }
        },
        async updateGLifeDesign({ commit }, data) {
          commit("loading", true);
          commit("setErrors", null);

          try {
            const { message } = await designs.updateGLifeDesign(data);
            notification.success(message);
          } catch (errors) {
            commit("setErrors", errors);
            notification.warning("Oops, something went wrong.");
          } finally {
            commit("loading", false);
          }
        },
        async publishGLifeDesign({ commit }, data) {
          commit("loading", true);
          commit("setErrors", null);

          try {
            const { message } = await designs.publishGLifeDesign(data);
            notification.success(message);
          } catch (errors) {
            commit("setErrors", errors);
            notification.warning("Oops, something went wrong.");
          } finally {
            commit("loading", false);
          }
        },
        async getGLifeDesignDetails({ commit }, uuid) {
          commit("loading", true);
          commit("setErrors", null);

          try {
              const { data } = await designs.getGLifeDesignDetails(uuid);

              commit("setGLifeDesignDetails", data);
          } catch (errors) {
              commit("setErrors", errors);
              notification.warning("Oops, something went wrong.");
          } finally {
              commit("loading", false);
          }
        },
        async deleteGLifeDesign({ commit }, uuid) {
          commit("loading", true);
          commit("setErrors", null);

          try {
            const { message } = await designs.deleteGLifeDesign(uuid);
            notification.success(message);
          } catch (errors) {
            commit("setErrors", errors);
            notification.warning("Oops, something went wrong.");
          } finally {
            commit("loading", false);
          }
        },
    }
};
